import {
  OneClickValidatePurchaseOrderActionTypes,
  OneClickValidatePurchaseOrderActions,
} from '../actions/one-click-validate-purchase-order.actions';
import { PurchaseOrderValidationResponseV4 } from '@cemex-core/cmx-api';

export interface OneClickPurchaseOrderState {
  loading: boolean;
  validated: PurchaseOrderValidationResponseV4;
}

export const initialState: OneClickPurchaseOrderState = {
  loading: false,
  validated: null,
};

export function reducer(
  state = initialState,
  action: OneClickValidatePurchaseOrderActions,
): OneClickPurchaseOrderState {
  switch (action.type) {
    case OneClickValidatePurchaseOrderActionTypes.LOAD_VALIDATE_PURCHASE_ORDER: {
      return {
        ...state,
        loading: true,
      } as OneClickPurchaseOrderState;
    }
    case OneClickValidatePurchaseOrderActionTypes.LOAD_VALIDATE_PURCHASE_ORDER_COMPLETE: {
      return {
        ...state,
        loading: false,
        validated: action.payload,
      } as OneClickPurchaseOrderState;
    }
    case OneClickValidatePurchaseOrderActionTypes.LOAD_ERROR:
    case OneClickValidatePurchaseOrderActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
